"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _isBoolean2 = _interopRequireDefault(require("lodash/isBoolean"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

var _OnClickOutside = _interopRequireDefault(require("../OnClickOutside"));

var _excluded = ["headRenderer", "contentRenderer"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AbstractDropdown = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(AbstractDropdown, _React$PureComponent);

  var _super = _createSuper(AbstractDropdown);

  function AbstractDropdown(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AbstractDropdown);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "dropdownRef", void 0);
    _this.state = {
      isOpen: Boolean(props.open)
    };
    _this.dropdownRef = /*#__PURE__*/_react["default"].createRef();
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(AbstractDropdown, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var isOpen = this.state.isOpen;

      if ((0, _isBoolean2["default"])(nextProps.open) && nextProps.open !== isOpen) {
        this.setState(function () {
          return {
            isOpen: nextProps.open
          };
        });
      }

      return null;
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(_ref) {
      var _this$dropdownRef, _this$dropdownRef$cur;

      var relatedTarget = _ref.relatedTarget;
      var autoClose = this.props.autoClose;

      if (autoClose && !((_this$dropdownRef = this.dropdownRef) !== null && _this$dropdownRef !== void 0 && (_this$dropdownRef$cur = _this$dropdownRef.current) !== null && _this$dropdownRef$cur !== void 0 && _this$dropdownRef$cur.contains(relatedTarget))) {
        this.toggle(false);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.toggle();
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      var autoOpen = this.props.autoOpen;

      if (autoOpen) {
        this.toggle(true);
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.toggle(false);
    }
  }, {
    key: "toggle",
    value: function toggle(flag, callback) {
      var _this2 = this;

      var isOpen = this.state.isOpen;

      if (flag === isOpen) {
        return;
      }

      this.setState(function (prevState) {
        return {
          isOpen: (0, _isBoolean2["default"])(flag) ? flag : !prevState.isOpen
        };
      }, function () {
        var onToggle = _this2.props.onToggle; // eslint-disable-next-line

        onToggle === null || onToggle === void 0 ? void 0 : onToggle(_this2.state.isOpen);

        if ((0, _isFunction2["default"])(callback)) {
          callback();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          headRenderer = _this$props.headRenderer,
          contentRenderer = _this$props.contentRenderer,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], (0, _extends2["default"])({}, props, {
        onClickOutside: this.handleClose,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }), /*#__PURE__*/_react["default"].createElement(StyledHeader, {
        functional: true,
        onClick: this.handleClick
      }, headRenderer()), isOpen && /*#__PURE__*/_react["default"].createElement(StyledContentContainer, {
        ref: this.dropdownRef
      }, /*#__PURE__*/_react["default"].cloneElement(contentRenderer(), {
        tabIndex: 0
      })));
    }
  }]);
  return AbstractDropdown;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(AbstractDropdown, "StyledContentContainer", void 0);
var StyledHeader = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "AbstractDropdown__StyledHeader",
  componentId: "sc-1jim6u3-0"
})(["width:100%;"]);

var StyledContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "AbstractDropdown__StyledContentContainer",
  componentId: "sc-1jim6u3-1"
})(["position:relative;"]);

AbstractDropdown.StyledContentContainer = StyledContentContainer;
var _default = AbstractDropdown;
exports["default"] = _default;